import { Routes } from "@angular/router";
import { AuthGuard } from "../../shared/authguards/auth.guard";
import { epakRoleGuard } from "../../shared/authguards/epak-role.guard";
import { reviewDraftGuard } from "../../shared/authguards/review-draft.guard";
import {ExternalPatientRoleGuard} from "src/app/shared/authguards/external-patient-role.guard";

export const DISEASE_ROUTES: Routes = [
  {
    path: "diseases",
    loadComponent: () => import("./disease.component").then(m => m.DiseaseComponent),
    canActivate: [AuthGuard, epakRoleGuard, ExternalPatientRoleGuard],
    data: { title: "pageTitles.diseases" },
    children: [
      {
        path: "",
        loadComponent: () => import("./disease-form-wrapper/disease-form-wrapper.component").then(m => m.DiseaseFormWrapperComponent),
        data: { title: "pageTitles.diseases" },
      },
      {
        path: "review",
        loadComponent: () => import("./disease-review-wrapper/disease-review-wrapper.component").then(m => m.DiseaseReviewWrapperComponent),
        canActivate: [reviewDraftGuard],
        data: { title: "pageTitles.diseasesReview" },
      },
      {
        path: "message",
        loadComponent: () => import("../message/message.component").then(m => m.MessageComponent),
        data: { title: "pageTitles.diseasesMessages" },
      },
      {
        path: "submitted",
        loadComponent: () => import("../../shared/components/submit-confirmation/submit-confirmation.component").then(m => m.SubmitConfirmationComponent),
        data: { title: "pageTitles.submitted" },
      },
    ],
  },
];
